export const readTextWithLineBreak = (text: string) => {
  return text.replace(/###newLine###/g, "\n");
};

export const writeTextWithLineBreak = (text: string) => {
  return text.replace(/(?:\r\n|\r|\n)/g, "###newLine###");
};

export const textWithLineBreakToArray = (text: string) => {
  return readTextWithLineBreak(text).split(/(?:\r\n|\r|\n)/g);
};
